<template>
  <table
    :class="[
      'basic-table',
      highlightRows ? 'highlight-rows' : '',
      pointerHover ? 'pointer-hover' : '',
    ]"
  >
    <thead>
      <tr>
        <slot name="headers">
          <th
            v-for="(header, key) in headers"
            :key="key"
            @click="emitOrderBy(header)"
          >
            <div class="table-header">
              <div>{{ header }}</div>
              <i
                :class="{'flip-arrow': direction === 'DESC' && header === currentOrderColumn}"
                class="icon arrow_down"
              />
            </div>
          </th>
        </slot>
      </tr>
    </thead>

    <tbody>
      <slot name="rows" />
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    highlightRows: {
      type: Boolean,
      default: false,
    },
    pointerHover: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['orderBy'],
  data() {
    return {
      direction: 'DESC',
      currentOrderColumn: null,
    }
  },
  methods: {
      emitOrderBy(column) {
        this.direction = this.currentOrderColumn === column ? (this.direction === 'ASC' ? 'DESC' : 'ASC') : 'DESC';
        this.currentOrderColumn = column
        this.$emit('orderBy', {column, direction: this.direction});
      },
  }
}
</script>

<style lang="scss" scoped>
.basic-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  :deep(th) {
    padding: 1rem;
    text-align: center;
  }

  :deep(td) {
    padding: .5rem 1rem;
  }

  :deep(tr td:first-of-type) {
    border-radius: 12px 0 0 12px;
  }

  :deep(tr td:last-of-type) {
    border-radius: 0 12px 12px 0;
  }

  :deep(tbody tr:nth-of-type(2n+1)) {
    background: var(--table-secondary-color);
    border-radius: 12px;
  }

  &.highlight-rows :deep(tbody tr:hover) {
    background: #DFF5EE;
  }

  &.pointer-hover :deep(tbody tr:hover) {
    cursor: pointer;
  }
}

.arrow_down {
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 2.5V13.5' stroke='%23040707' stroke-width='0.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M3.5 9L8 13.5L12.5 9' stroke='%23040707' stroke-width='0.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}

.table-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.flip-arrow {
  transform: rotate(180deg);
}
</style>
